import 'css-chunksrc/client/pages/projectPage/wbsPage/heading/styles.scss';export default {
  "heading": "_heading_o8l5s_1",
  "row": "_row_o8l5s_8",
  "columns": "_columns_o8l5s_18",
  "label": "_label_o8l5s_27",
  "hide": "_hide_o8l5s_35",
  "contextualMenu": "_contextualMenu_o8l5s_39",
  "contextualMenuIcon": "_contextualMenuIcon_o8l5s_43",
  "wbsConfigurationIcon": "_wbsConfigurationIcon_o8l5s_51"
};